module.exports = {
	mounted() {
		// eslint-disable-next-line
		$(this.$el).foundation();
	},
	destroyed() {
		// eslint-disable-next-line
		try {
			$(this.$el).foundation.destroy();
			// eslint-disable-next-line
		} catch(err) {}
	},
};